<ion-toolbar class="content-width" *ngIf="organisationId">
    <div class="season-select-center">
        <app-season-selector #seasonSelector [organisationId]="organisationId"></app-season-selector>
    </div>
</ion-toolbar>
@defer (when isLoading === true) {
@if (!team?.participants?.length) {
<app-empty-page class="content-width" *ngIf="!isLoading" text="{{'There are not any player on this team' | translate}}"
    iconName="people"></app-empty-page>
} @else {
<ion-list class="content-width">
    <div *ngIf="isOwner && hasPendingRequest" class="pending-request-box ion-padding content-width ">
        <p>
            {{ pendingRequestsCount }}
            {{ pendingRequestsCount > 1 ? ('players requested to claim profiles' | translate) : ('player requested to
            claim profile' | translate) }}
        </p>
        <ion-icon name="information" size="large"></ion-icon>
    </div>
    <div class="player-count-wrapper">
        <div class="player-count">{{team?.participants.length}}</div>
    </div>
    @for (p of team?.participants; track $index) {
    <ion-item-sliding #slidingItem>
        <app-player-item [user]="p.person"
            [showApprove]="(p.person?.claim_status === 'pending' && isOwner) || (p.person?.claimedBy?._id === userId && p.person?.claim_status === 'pending')"
            (click)="goToProfilePage(p)" (onPrimary)="isOwner ? approvePlayer($index) : revokePlayer($index)"
            [primaryText]="isOwner ? 'Approve' : 'Pending'" [isOwner]="isOwner">
        </app-player-item>
        @if (isOwner && (
        ( !['ITA','USTA'].includes(team?.organisations?.[0]?.organisationAbbreviation)
        && !['ITA','USTA'].includes(team?.organisation?.organisationAbbreviation) )
        || team?.organisations?.[0]?.allowRemovePlayer
        || team?.organisations?.allowRemovePlayer
        )) {
        <ion-item-options side="end">
            <ion-item-option (click)="removePlayer(p.person._id, slidingItem)" color="danger">
                {{ 'Remove' | translate }}
            </ion-item-option>
        </ion-item-options>
        }
    </ion-item-sliding>
    }
</ion-list>
}

@if (((isOwner && team?.authentication?.status) || isOfficial) && team.organisations?.length) {
<ion-button (click)="synchronizeRoster()" fill="clear" expand="block">
    <ion-icon slot="start" name="sync-outline"></ion-icon>
    Synchronize Roster
</ion-button>
}
}
@if(isLoading) {
<div class="ion-padding content-width" *ngFor="let item of [0, 1, 2]">
    <ion-skeleton-text animated style="width: 30%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
    <ion-skeleton-text animated style="width: 100%"></ion-skeleton-text>
</div>
}